package com.imobly.imobly.ui.components.input

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Icon
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.TextFieldDefaults
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Visibility
import androidx.compose.material.icons.filled.VisibilityOff
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.PasswordVisualTransformation
import androidx.compose.ui.text.input.VisualTransformation
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.imobly.imobly.ui.components.messageerror.MessageErrorComp
import com.imobly.imobly.ui.theme.colors.BackGroundColor
import com.imobly.imobly.ui.theme.colors.PrimaryColor
import com.imobly.imobly.ui.theme.colors.ReadOnlyColor
import com.imobly.imobly.ui.theme.fonts.montserratFont
import org.jetbrains.compose.ui.tooling.preview.Preview

@Composable
fun InputPasswordComp(
    label: String,
    placeholder: String,
    value: String,
    onValueChange: (String) -> Unit,
    passwordVisible: Boolean = false,
    changePasswordVisible: () -> Unit,
    readOnly: Boolean = false,
    isError: Boolean = false,
    errorMessage: String = "",
    modifier: Modifier = Modifier.padding(16.dp).fillMaxWidth()
) {

    val textColor = if (readOnly) ReadOnlyColor else Color.Black
    val labelColor = if (readOnly) ReadOnlyColor else PrimaryColor
    val indicatorColor = if (readOnly) ReadOnlyColor else PrimaryColor
    val backgroundColor = if (readOnly) BackGroundColor.copy(alpha = 0.5f) else BackGroundColor
    val iconColor = if (readOnly) ReadOnlyColor else PrimaryColor

    Column(
        modifier = modifier,
        horizontalAlignment = Alignment.Start
    ) {
        OutlinedTextField(
            label = {
                Text(
                    label,
                    fontFamily = montserratFont(),
                    fontSize = 15.sp,
                    fontWeight = FontWeight.ExtraBold,
                    color = labelColor
                )
            },
            onValueChange = {
                if (!readOnly) {
                    onValueChange(it)
                }
            },
            value = value,
            shape = RoundedCornerShape(10.dp),
            singleLine = true,
            placeholder = {
                Text(
                    placeholder,
                    fontFamily = montserratFont(),
                    fontSize = 15.sp,
                    fontWeight = FontWeight.ExtraBold,
                    color = labelColor.copy(alpha = 0.5f)
                )
            },
            readOnly = readOnly,
            isError = isError,
            visualTransformation = if (passwordVisible) VisualTransformation.None else PasswordVisualTransformation(),
            textStyle = TextStyle(
                fontFamily = montserratFont(),
                fontSize = 15.sp,
                fontWeight = FontWeight.Bold,
                color = textColor
            ),
            modifier = Modifier.fillMaxWidth(),
            trailingIcon = {
                if (!readOnly) {
                    Icon(
                        imageVector = if (passwordVisible) {
                            Icons.Filled.Visibility
                        } else {
                            Icons.Filled.VisibilityOff
                        },
                        contentDescription = "Trocar visibildade da senha",
                        tint = iconColor,
                        modifier = Modifier
                            .size(20.dp)
                            .clickable {
                                if (!readOnly) {
                                    changePasswordVisible()
                                }
                            },
                    )
                }
            },
            colors = TextFieldDefaults.colors(
                unfocusedTextColor = textColor,
                unfocusedLabelColor = labelColor,
                unfocusedIndicatorColor = indicatorColor,
                unfocusedContainerColor = backgroundColor,
                focusedContainerColor = backgroundColor,
                focusedTextColor = textColor,
                focusedLabelColor = labelColor,
                focusedIndicatorColor = indicatorColor,
                errorContainerColor = backgroundColor,
                errorIndicatorColor = Color.Red,
                errorLabelColor = Color.Red,
                errorTextColor = Color.Red
            )
        )
        if (isError) {
            MessageErrorComp(errorMessage)
        }
    }
}

@Preview
@Composable
fun InputPasswordCompPreview() {
    Box(
        Modifier.fillMaxSize(),
        contentAlignment = Alignment.Center
    ) {
        InputPasswordComp(
            "Example",
            "Text for example",
            "",
            {},
            false,
            {}
        )
    }
}